export const changeSidebarArteFinalOption = (value, currentOption, setCurrentOption) => {
  if (value === currentOption) {
    setCurrentOption(null);
  } else {
    setCurrentOption(value);
  }
};
